import { z } from 'zod';
import { defineTool } from './types.ts';

export const practiceQuestions = defineTool({
  name: 'generate_practice_questions',
  description:
    "Generate tailored practice questions for the user's target role, company and round. Takes a few seconds; keep talking while it runs. When the result arrives, show the questions with render_card.",
  params: z.object({
    role: z.string().min(1).max(80),
    company: z.string().max(80).optional(),
    round: z.string().max(60).optional(),
    count: z.number().int().min(1).max(8).default(5),
  }),
  execution: 'server',
  behavior: 'NON_BLOCKING',
  fixtures: [
    { name: 'amazon-pm', params: { role: 'Product Manager', company: 'Amazon', round: 'behavioral', count: 3 } },
  ],
});

export const practiceQuestionsResult = z.object({ questions: z.array(z.string()).min(1) });
